import React, { useMemo } from 'react';
import styled from 'styled-components';

import ModuloCard from './ModuloCard';
import ModuloCardAdicionado from './ModuloCardAdicionado';
import ModulosDiferencaView from './ModulosDiferencaView';

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0;
`;

const SectionHeader = styled.div<{ $color?: string }>`
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 14px;
  color: ${props => props.$color || '#495057'};
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PlaceholderMessage = styled.div`
  padding: 10px;
  background-color: #e9ecef;
  border-radius: 4px;
  color: #6c757d;
  font-style: italic;
  font-size: 13px;
`;

export const ModulosGridFull = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 8px;
`;

type Props = {
  modulosAtuais?: string[];
  adicionados?: string[];
  removidos?: string[];
  getModuloDescricao?: (nomeModulo: string) => string;
  showDiferencas?: boolean;
  showModulosFinais?: boolean;
};

const ModulosExpandedView: React.FC<Props> = ({
  modulosAtuais = [],
  adicionados = [],
  removidos = [],
  getModuloDescricao = (modulo: string) => modulo,
  showDiferencas = true,
  showModulosFinais = true
}) => {
  const temMudancas = adicionados.length || removidos.length;

  const modulosOrdenados = useMemo(() => {
    return [...modulosAtuais].sort((a, b) =>
      getModuloDescricao(a).localeCompare(getModuloDescricao(b))
    );
  }, [modulosAtuais, getModuloDescricao]);

  return (
    <MainContainer>
      {showDiferencas && temMudancas && (
        <ModulosDiferencaView
          adicionados={adicionados}
          removidos={removidos}
          getModuloDescricao={getModuloDescricao}
        />
      )}

      {showModulosFinais && (
        <div>
          <SectionHeader>
            <i className="fa fa-check-circle" />
            Módulos Finais ({modulosAtuais.length})
          </SectionHeader>
          {modulosAtuais.length === 0 ? (
            <PlaceholderMessage>Nenhum módulo ativo</PlaceholderMessage>
          ) : (
            <ModulosGridFull>
              {modulosOrdenados.map(modulo => {
                const foiAdicionado = adicionados.includes(modulo);
                return foiAdicionado ? (
                  <ModuloCardAdicionado key={modulo}>
                    {getModuloDescricao(modulo)}
                  </ModuloCardAdicionado>
                ) : (
                  <ModuloCard key={modulo}>
                    {getModuloDescricao(modulo)}
                  </ModuloCard>
                );
              })}
            </ModulosGridFull>
          )}
        </div>
      )}
    </MainContainer>
  );
};

export default ModulosExpandedView;
